import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetConsultProtocolsTrack,
	ConsultProtocolsTrackModel,
	ConsultProtocolsTrackParams,
} from 'domain/usecases/private/consult-protocols/get-consult-protocols-track';

export class RemoteGetConsultProtocolsTrack implements GetConsultProtocolsTrack {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ConsultProtocolsTrackModel>,
	) {}

	async get({
		signal,
		...params
	}: ConsultProtocolsTrackParams): Promise<ConsultProtocolsTrackModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
